import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';

// Legacy core-components <Header> (catalog-graph) an den Clean-Light-Look der
// BUI-Header angleichen: weisser Grund, navy Titel. pageTheme ist die einzige
// Stelle, an der der alte Header faerbbar ist; der neue BUI-Header ignoriert es.
const flatPageTheme = {
  colors: ['#1F305A'],
  shape: '',
  backgroundImage: 'linear-gradient(90deg, #FFFFFF, #FFFFFF)',
  fontColor: '#1F305A',
};

export const tallenceLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#1F305A',
        light: '#005BAA',
        dark: '#1F305A',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#F15060',
        light: '#F15060',
        dark: '#d13040',
        contrastText: '#FFFFFF',
      },
      navigation: {
        background: '#1F305A',
        indicator: '#F15060',
        color: '#FFFFFF',
        selectedColor: '#FFFFFF',
        navItem: {
          hoverBackground: '#005BAA',
        },
        submenu: {
          background: '#1F305A',
        },
      },
      background: {
        default: '#F3F3F3',
        paper: '#FFFFFF',
      },
    },
  }),
  defaultPageTheme: 'home',
  fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
  pageTheme: {
    home: flatPageTheme,
    documentation: flatPageTheme,
    tool: flatPageTheme,
    service: flatPageTheme,
    website: flatPageTheme,
    library: flatPageTheme,
    other: flatPageTheme,
    app: flatPageTheme,
    apis: flatPageTheme,
    card: flatPageTheme,
  },
});
